<template>
    <div id="user-cart" :class="{open: cartOpen}">
        <div class="grid h-24 bg-leonard-green place-items-center">
            <h4 class="text-center text-leonard-white">My Cart ({{totalQty}})</h4>
            <font-awesome-icon fixed-width class="absolute top-3 right-3 h3 font-medium transition-all duration-300 border-2 rounded-md inline-block bg-transparent border-transparent text-leonard-white hover:text-leonard-white-hover cursor-pointer" :icon="['fas', 'xmark']" @click="toggleCart(false)"></font-awesome-icon>
        </div>

        <div class="items">
            <div class="text-center italic mt-3" v-if="items.length < 1">
                Your cart is empty.
                <br />
                <router-link :to="{name: 'order'}" @click.native="toggleCart(false)" class="text-leonards-green underline hover:text-leonard-green-hover hover:no-underline">
                    Order your photos now?
                </router-link>
            </div>
            <div v-else>
                <div class="flex items-start py-2" :class="{'bg-light': (index % 2) === 0 || index === 0}" v-for="(item, index) in items" :key="index">
                    <div class="px-2" v-if="loading === index">
                        <font-awesome-icon fixed-width class="h-6 w-6 text-gray-900" icon="spinner" spin></font-awesome-icon>
                    </div>
                    <div class="px-2" v-else>
                        <font-awesome-icon fixed-width class="h-6 w-6 text-leonard-error pt-1 remove" :icon="['far', 'circle-xmark']" @click="removeItem(item, index)"></font-awesome-icon>
                    </div>
                    <div class="flex-grow px-2">
                        <h6 class="border-b pb-1">{{item.name}}</h6>
                        <div class="flex items-center justify-between">
                            <span class="text-sm font-semibold">${{parseFloat(item.price) | formatMoney}}</span>
                        </div>
                        <div class="text-sm" v-if="item.subItems">
                            <ul class="list-disc list-outside pl-3 mt-1">
                                <li v-for="(sub, i) in item.subItems" :key="i">
                                    {{sub.name}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-leonard-black text-leonard-white p-3 totals">
            <div class="flex items-center justify-between mb-2">
                <div class="tracking-wider">Subtotal:</div>
                <div class="text-xl font-bold">${{parseFloat(total) | formatMoney}}</div>
            </div>
            <button
                type="button"
                class="font-medium transition-all duration-300 border-2 rounded-md block w-full py-2 px-3 md:px-4 bg-leonard-green border-transparent text-leonard-white hover:bg-leonard-green-hover focus:ring-leonard-green cursor-pointer disabled:bg-leonard-green-disabled disabled:text-leonard-green disabled:cursor-not-allowed"
                @click="goToCheckout"
                v-if="totalQty > 0"
            >
                Checkout
            </button>
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faXmark, faSpinner, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
    import { faXmarkCircle } from '@fortawesome/free-regular-svg-icons';
    import Cart from '../../classes/Cart';

    export default {
        data() {
            return {
                cartOpen: false,
                items: [],
                totalQty: 0,
                total: 0.00,
                loading: null,
            }
        },

        created() {
            library.add(faXmark, faSpinner, faXmarkCircle, faMinusCircle);
        },

        mounted() {
            this.getCart();

            window.events.$on('toggleCart', this.toggleCart);
            window.events.$on('addToCart', this.getCart);
            window.events.$on('refreshCart', this.getCart);
        },

        methods: {
            getCart() {
                let self = this;
                let cart = new Cart();
                let user_id = this.$auth.user().details.id;

                cart.getCart(user_id).then(function(response) {
                    self.items = [];
                    self.totalQty = 0;
                    self.total = 0.00;

                    const data = response.data;
                    data.items.forEach(function(item) {
                        self.addItem(item);
                        if(!item.parent_id || item.parent_id === 0) self.totalQty++;
                    });

                    if(data.items.length > 0) {
                        if(localStorage.getItem('access_code') === null) localStorage.setItem('access_code', data.items[0].access_code);
                        if(localStorage.getItem('con_no') === null) localStorage.setItem('con_no', data.items[0].contract_number);
                        if(localStorage.getItem('school') === null) localStorage.setItem('school', data.items[0].school_id);
                    }

                    window.events.$emit('setCartCount', self.totalQty);
                });
            },

            toggleCart(open = null) {
                // Toggle will set manually if a paramter is passed, otherwise it will toggle
                if(open !== null) this.cartOpen = open;
                else this.cartOpen = !this.cartOpen;

                this.cartOpen ? document.querySelector('body').classList.add('cart-open') : document.querySelector('body').classList.remove('cart-open');
            },

            addItem(product) {
                let newItem = true;

                this.items.some(function(item) {
                    // if(product.package_number == item.package_number) {
                    //     newItem = false;
                    //     item.qty++;
                    //     return;
                    // }

                    if(product.parent_id === item.id) {
                        newItem = false;
                        item.subItems.push({
                            id: product.id,
                            pkg: product.package_number,
                            name: product.name,
                        });
                        item.subtotal = parseFloat(item.price) + parseFloat(product.price);

                        return true;
                    }
                });

                if(newItem) {
                    this.items.push({
                        id: product.id,
                        package: product.package_number,
                        name: product.name,
                        contents: product.contents,
                        price: product.price,
                        subtotal: product.price,
                        qty: 1,
                        subItems: []
                    });
                }

                this.total += parseFloat(product.price);
            },

            removeItem(item, index) {
                let self = this;
                let cart = new Cart();
                let data = {
                    user_id: this.$auth.user().details.id,
                    item: item,
                    type: 'remove'
                };
                this.loading = index;

                cart.removeItem(data, data.user_id).then(function(response) {
                    // console.log(response.data);
                    self.getCart();
                    self.loading = null;
                    self.items.splice(index, 1);
                }).then(function() {
                    window.events.$emit('refreshCheckout');
                });
            },

            goToCheckout() {
                this.toggleCart();
                this.$router.push({
                    name: 'order',
                    params: { step: 'checkout' }
                })
            },
        },

        filters: {
            formatMoney(amount) {
                return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .remove {
        cursor: pointer;
    }

    .items {
        overflow-y: auto;
        height: calc(100% - 154.85px);
        scrollbar-color: #373737 transparent;
        scrollbar-width: thin;
        &::-webkit-scrollbar {
            background: #F0F0F0;
            width: 5px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 1rem;
            background: #373737;
        }
    }
</style>
